import { Input, SelectProps } from '~/components/Input';
import { useDistrictListQuery } from '../queries';
import { ForwardedRef, forwardRef } from 'react';
import { BaseFormState } from '~/types/BaseFormState';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  addNationalRecordOption?: boolean;
};

function DistrictSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { addNationalRecordOption, ...restProps } = props;
  const { data, isLoading } = useDistrictListQuery({ page_size: 100 });

  const options = data?.results.map(d => [d.name, d.id] as [string, number]) ?? [];
  if (addNationalRecordOption) {
    options.unshift(['Svenska rekord', 0]);
  }

  return (
    <Input.Select
      options={options}
      placeholder={props.placeholder ?? 'Alla distrikt'}
      aria-label={props['aria-label'] ?? 'Distrikt'}
      disabled={isLoading || props.disabled}
      ref={ref}
      {...restProps}
    />
  );
}

export const DistrictSelect = forwardRef(DistrictSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof DistrictSelectElement>;
